export default __webpack_public_path__ + "static/pdr-logo_2x-a9aa17abb46a7af84cd791867a6031ec.png";